import { useEffect } from 'react';

import PropTypes from 'prop-types';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { onlyNumber } from 'utils/formatter';

import Grid from '@material-ui/core/Grid';

import { Select, Textfield, TextLabel } from 'components/common';

import { DEFAULT_CURRENCY_KEY } from 'settings/constants/registration';
import { ACCOUNT_NUMBER_MAX_LENGTH, PIN_MAX_LENGTH } from 'settings/constants/common';

const AccountForm = ({ accountNumber, pin, selectedCurrency, handleChange }) => {
  const { formatMessage } = useIntl();
  const { currencies } = useSelector(({ SelfUnlockReducer }) => SelfUnlockReducer);

  const resetFormState = () => ['accountNumber', 'pin', 'selectedCurrency'].map(state => handleChange(state, ''));

  // when component unmount remove state to avoid autofilled form when user open selfUnlock again
  useEffect(() => () => resetFormState(), []);

  return (
    <>
      <Grid container spacing={1} alignItems="center" className="form-spacing">
        <Grid item xs={12} sm={5}>
          <TextLabel
            hasIcon
            isAssetIcon
            className="ml2"
            label={formatMessage({ id: 'selfUnlock.accountNumber' })}
            tooltipTitle={formatMessage({ id: 'selfUnlock.modal.container.account.accountNumberTooltip' })}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <Select
            id="currency_code"
            fullWidth
            options={currencies}
            value={selectedCurrency}
            onChange={e => handleChange('selectedCurrency', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <Textfield
            id="accountNumber"
            value={accountNumber}
            maxLength={ACCOUNT_NUMBER_MAX_LENGTH}
            onChange={e => handleChange('accountNumber', onlyNumber(e.target.value))}
            placeholder={formatMessage({ id: 'selfUnlock.modal.container.account.accountNumberPlaceholder' })}
          />
        </Grid>
      </Grid>

      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12} sm={5}>
          <TextLabel
            hasIcon
            isAssetIcon
            className="ml2"
            label={formatMessage({ id: 'selfUnlock.modal.container.account.pin' })}
            tooltipTitle={formatMessage({ id: 'selfUnlock.modal.container.account.pinTooltip' })}
          />
        </Grid>
        <Grid item xs={12} sm={7}>
          <Textfield
            id="pin"
            value={pin}
            type="password"
            maxLength={PIN_MAX_LENGTH}
            onChange={e => handleChange('pin', onlyNumber(e.target.value))}
            placeholder={formatMessage({ id: 'selfUnlock.modal.container.account.pinPlaceholder' })}
          />
        </Grid>
      </Grid>
    </>
  );
};

AccountForm.propTypes = {
  pin: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  accountNumber: PropTypes.string.isRequired,
  selectedCurrency: PropTypes.string.isRequired,
};

export default AccountForm;
